import axios from "axios";
import endpoints from "@/api/endpoints";
import { createCartData } from "./utils/createCartData";
import { createArrayCartData } from "./utils/createArrayCartData";

export class CartService {
  static __instance = null;

  constructor() {
    if (CartService.__instance) {
      return CartService.__instance;
    }

    CartService.__instance = this;
  }

  setHeaderQuantity(quantity) {
    const cartHeaderCounter = document.querySelector("#js-cart-counter");
    if (cartHeaderCounter) cartHeaderCounter.innerText = quantity || 0;
  }

  addToCart(item, options) {
    const data = createCartData(item, "add", options);

    return new Promise((resolve, reject) => {
      axios
        .post(endpoints.cart.actions, data)
        .then(response => {
          if (response.data) {
            this.setHeaderQuantity(response.data.items_count);
            return resolve(response.data);
          } else return reject("Server error");
        })
        .catch(err => reject(err));
    });
  }

  addArrayItemsToCart(itemsArray) {
    const data = createArrayCartData(itemsArray, "addAll");

    return new Promise((resolve, reject) => {
      axios
        .post(endpoints.cart.actions, data)
        .then(response => {
          if (response.data) {
            this.setHeaderQuantity(response.data.items_count);
            return resolve(response.data);
          } else return reject("Server error");
        })
        .catch(err => reject(err));
    });
  }

  updateItemQuantity(item) {
    const data = createCartData(item, "update");

    return new Promise((resolve, reject) => {
      axios
        .post(endpoints.cart.actions, data)
        .then(response => {
          if (response.data) {
            this.setHeaderQuantity(response.data.items_count);
            return resolve(response.data);
          } else return reject("Server error");
        })
        .catch(err => reject(err));
    });
  }

  changeUnrecognizedItem(article, item) {
    let data = new FormData();

    data.append("id", item.id);
    data.append("basketId", item.basketId);
    data.append("newId", article.id);

    return new Promise((resolve, reject) => {
      axios
        .post(endpoints.cart.changeUnrecognizedItem, data)
        .then(response => {
          if (response.success) {
            return resolve(response);
          } else return reject("Server error");
        })
        .catch(err => reject(err));
    });
  }

  updateUnrecognizedItem(item) {
    let data = new FormData();

    data.append("id", item.id);
    data.append("name", item.name);
    data.append("oem", item.oem);
    data.append("query", item.oem);
    data.append("perPage", 10);

    return new Promise((resolve, reject) => {
      axios
        .post(endpoints.cart.searchArticles, data)
        .then(response => {
          if (response.data) {
            return resolve(response.data.data.articles);
          } else return reject("Server error");
        })
        .catch(err => reject(err));
    });
  }

  updateItemUserPrice(item) {
    const data = createCartData(item, "updateUserPrice");

    return axios.post(endpoints.cart.actions, data).then(response => {
      if (response.data) {
        return;
      }
      throw new Error();
    });
  }

  removeFromCart(item) {
    const data = createCartData(item, "remove");

    return new Promise((resolve, reject) => {
      axios
        .post(endpoints.cart.actions, data)
        .then(response => {
          if (response.data) {
            this.setHeaderQuantity(response.data.items_count);
            return resolve(response.data);
          } else return reject("Server error");
        })
        .catch(err => reject(err));
    });
  }

  removeAllFromCart() {
    const data = new FormData();
    data.append("action", "remove_all");

    return new Promise((resolve, reject) => {
      axios
        .post(endpoints.cart.actions, data)
        .then(response => {
          if (response.data) {
            this.setHeaderQuantity(response.data.items_count);
            return resolve(response.data);
          } else return reject("Server error");
        })
        .catch(err => reject(err));
    });
  }

  createDeal(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(endpoints.cart.createDeal, data)
        .then(response => {
          if (response.data) {
            this.setHeaderQuantity(response.data.items_count);
            return resolve(response.data);
          } else return reject("Server error");
        })
        .catch(err => reject(err));
    });
  }

  getCart() {
    return new Promise((resolve, reject) => {
      axios
        .get(endpoints.cart.list)
        .then(response => {
          if (response.data) {
            return resolve(response.data);
          } else return reject("Server error");
        })
        .catch(err => reject(err));
    });
  }

  getCartItems() {
    return new Promise((resolve, reject) => {
      axios
        .get(endpoints.cart.preview)
        .then(response => {
          if (response.data) {
            return resolve(response.data);
          } else return reject("Server error");
        })
        .catch(err => reject(err));
    });
  }

  removeAttachedFile(id) {
    return new Promise((resolve, reject) => {
      axios
        .post(endpoints.cart.removeAttachedFile, { id })
        .then(response => {
          if (response.data.success) {
            return resolve();
          } else return reject("Server error");
        })
        .catch(err => reject(err));
    });
  }

  updateUserPriceStatus(data) {
    return axios
      .post(endpoints.cart.updateUserPriceStatus, data)
      .then(response => {
        if (response.data.success) {
          return undefined;
        } else throw new Error();
      });
  }
}

export const cartService = new CartService();
